import { SupplyPartRenderer } from "@project/emerge";
import { MESH_INFO_MATERIAL_SHEETMETAL_KEY } from "@project/emerge-types";

interface SupplyPartRendererBlingProps {
  id: string;
}

// Spezialisierter Renderer für Teile (z. B. Ecken), der das glänzende
// Blech-Material anwendet, um den Kontrast zu den matten Aluminiumprofilen zu
// erhöhen. SupplyPartRenderer trägt das Material anhand des forcedMaterialKey
// selbst auf alle Meshes auf.
export const SupplyPartRendererBling = ({
  id,
}: SupplyPartRendererBlingProps) => (
  <SupplyPartRenderer
    id={id}
    forcedMaterialKey={MESH_INFO_MATERIAL_SHEETMETAL_KEY}
  />
);
